"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Icon_1 = __importDefault(require("../../Icon/Icon"));
const SingleActionCard = (props) => {
    return (React.createElement("div", { className: "single-action-card", onClick: props.action },
        React.createElement("div", { className: "header" },
            typeof props.title === 'string' ?
                React.createElement("div", null,
                    React.createElement("h2", null, props.title)) :
                React.createElement("div", null,
                    React.createElement("p", null, props.title.top),
                    React.createElement("h3", null, props.title.bottom)),
            React.createElement(Icon_1.default, { className: "arrow-right", icon: "arrow_right" }))));
};
exports.default = SingleActionCard;
//# sourceMappingURL=SingleActionCard.js.map